import { createThunklessAction } from 'thunkless';

import { avo } from '@/api/app/avo-client';
import { Without } from '@/types/generic';
import { inboxLoadingStatusSelector } from '../selectors/inbox';

export enum InboxTypes {
  FETCH_INBOX_TICKETS_REQUEST = 'app/inbox/FETCH_INBOX_TICKETS_REQUEST',
  FETCH_INBOX_TICKETS_SUCCESS = 'app/inbox/FETCH_INBOX_TICKETS_SUCCESS',
  FETCH_INBOX_TICKETS_FAILURE = 'app/inbox/FETCH_INBOX_TICKETS_FAILURE',

  FETCH_INBOX_USERS_REQUEST = 'app/inbox/FETCH_INBOX_USERS_REQUEST',
  FETCH_INBOX_USERS_SUCCESS = 'app/inbox/FETCH_INBOX_USERS_SUCCESS',
  FETCH_INBOX_USERS_FAILURE = 'app/inbox/FETCH_INBOX_USERS_FAILURE',

  TOGGLE_ZOOMED_IN_MEDIA_MODAL = 'app/inbox/TOGGLE_ZOOMED_IN_MEDIA_MODAL',
}

export type FetchInboxTicketsParams = Without<Parameters<typeof avo.tickets>[0], 'query'>&{ search?: string };
export const fetchInboxTickets =
  ({ search, ...rest }: FetchInboxTicketsParams) => createThunklessAction({
    type: [
      InboxTypes.FETCH_INBOX_TICKETS_REQUEST,
      InboxTypes.FETCH_INBOX_TICKETS_SUCCESS,
      InboxTypes.FETCH_INBOX_TICKETS_FAILURE,
    ] as const,
    promise: () => avo.tickets({ ...rest, query: search }),
    statusSelector: inboxLoadingStatusSelector,
    meta: { search, ...rest } as FetchInboxTicketsParams,
  });

export const fetchInboxUsers =
  (subdomain) => createThunklessAction({
    type: [
      InboxTypes.FETCH_INBOX_USERS_REQUEST,
      InboxTypes.FETCH_INBOX_USERS_SUCCESS,
      InboxTypes.FETCH_INBOX_USERS_FAILURE,
    ] as const,
    promise: () => avo.ajax({ route: '/v1/users', params: { subdomain } }),
    statusSelector: inboxLoadingStatusSelector,
    meta: { subdomain },
  });

export const toggleZoomedInMediaModal =
  (media: { url: string, mime: string, dimensions?: { w: number, h: number } }) => ({
    type: InboxTypes.TOGGLE_ZOOMED_IN_MEDIA_MODAL as const,
    payload: media,
  });
